var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 13.4167V0H3.49967V13.4167H2.33301Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50423 13.8292L0.170898 11.4959L0.995856 10.6709L2.91671 12.5918L4.83756 10.6709L5.66252 11.4959L3.32919 13.8292C3.10138 14.057 2.73204 14.057 2.50423 13.8292Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.083 4.66667H7.58301V3.5H11.083V4.66667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91667 9.33341H7V8.16675H11.0833C11.3043 8.16675 11.5063 8.29158 11.6051 8.48921C11.7039 8.68683 11.6826 8.92332 11.55 9.10008L8.75 12.8334H11.6667V14.0001H7.58334C7.36239 14.0001 7.1604 13.8752 7.06159 13.6776C6.96278 13.48 6.9841 13.2435 7.11667 13.0667L9.91667 9.33341Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85554 0.322458C9.75672 0.124834 9.55477 0 9.33381 0C9.11284 0 8.91089 0.124834 8.81207 0.322458L6.05664 5.83333H7.36097L9.33381 1.88771L11.3066 5.83333H12.611L9.85554 0.322458Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.be337d646b4b2d9cf1fb342af0f15423.svg";
export { ForwardRef as ReactComponent };